import { useState } from 'react';

import {
  ColumnConfiguration,
  ColumnConfigurationRenderAs,
} from '@april9au/stack9-sdk';
import { S9Button, Space, useRefreshList } from '@april9au/stack9-ui';

import { ListTable } from '../../components/ListTable/ListTable';
import { RequirementDrawer } from '../../components/RequirementDrawer/RequirementDrawer';
import { Requirement } from '../../models/stack9/Requirement';

const Button = S9Button.default;

type Props = {
  countryTemplateId: number;
  initialValues?: Partial<Requirement>;
};

const RequirementInfo = ({ countryTemplateId, initialValues }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();

  const columns: ColumnConfiguration[] = [
    {
      label: 'Code',
      field: 'code',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{code}}',
      options: {
        linkProp: '/ccfg/requirement-detail/{{id}}',
      },
    },
    {
      label: 'Section name',
      field: 'section_name',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{requirement_section.name}}',
    },
    {
      label: 'Question',
      field: 'question',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{question}}',
    },
    {
      label: 'Sequence',
      field: 'sequence',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{sequence}}',
    },
    {
      label: 'Question type',
      field: 'question_type',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{question_type}}',
    },
    {
      label: 'Is mandatory',
      field: 'is_mandatory',
      renderAs: ColumnConfigurationRenderAs.EnumTags,
      value: '{{is_mandatory}}',
      options: {
        enumColor: {
          Yes: 'green',
          No: 'red',
        },
      },
    },
    {
      label: 'Preserve for renewal',
      field: 'preserve_for_renewal',
      renderAs: ColumnConfigurationRenderAs.EnumTags,
      value: '{{preserve_for_renewal}}',
      options: {
        enumColor: {
          Yes: 'green',
          No: 'red',
        },
      },
    },
    {
      label: 'Is active',
      field: 'is_active',
      renderAs: ColumnConfigurationRenderAs.EnumTags,
      value: '{{is_active}}',
      options: {
        enumColor: {
          Yes: 'green',
          No: 'red',
        },
      },
    },
    {
      label: 'Base requirement code',
      field: 'base_requirement.code',
      renderAs: ColumnConfigurationRenderAs.Text,
      value: '{{base_requirement.code}}',
      options: {
        linkProp: '/ccfg/base-requirement-detail/{{base_requirement_id}}',
      },
    },
  ];

  return (
    <ListTable
      showFilter
      searchFields={[
        'code',
        'question',
        'base_requirement.code',
        'base_requirement.question',
        'requirement_section.name',
      ]}
      queryVars={{ countryTemplateId }}
      columns={columns}
      title="Requirements"
      queryName="getrequirementsbycountrytemplate"
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          marginBottom: '15px',
        }}
      >
        <Space>
          <Button
            label="Create"
            onClick={() => setIsOpen(true)}
            type="primary"
          />
        </Space>
        <RequirementDrawer
          initialValues={initialValues}
          open={isOpen}
          onClose={() => {
            setIsOpen(false);
            refresh();
          }}
        />
      </div>
    </ListTable>
  );
};

export default RequirementInfo;
